export interface Cue {
  index: number
  start: string
  end: string
  text: string
}

const TIMING_REGEX =
  /^(\d{2}:\d{2}:\d{2}\.\d{3}|\d{2}:\d{2}\.\d{3})\s*-->\s*(\d{2}:\d{2}:\d{2}\.\d{3}|\d{2}:\d{2}\.\d{3})/

const TIMESTAMP_VALIDATE_REGEX =
  /^(\d{2}:\d{2}:\d{2}\.\d{3}|\d{2}:\d{2}\.\d{3})$/

export function isValidTimestamp(value: string): boolean {
  return TIMESTAMP_VALIDATE_REGEX.test(value)
}

export function serializeVtt(cues: Cue[]): string {
  let out = 'WEBVTT\n\n'
  for (const cue of cues) {
    out += `${cue.start} --> ${cue.end}\n${cue.text}\n\n`
  }
  return out
}

export function parseVtt(vtt: string): Cue[] {
  const lines = vtt.replace(/\r\n/g, '\n').split('\n')
  const cues: Cue[] = []
  let i = 0

  while (i < lines.length) {
    const timingMatch = lines[i].match(TIMING_REGEX)
    if (timingMatch) {
      i++
      const textLines: string[] = []
      while (i < lines.length && lines[i].trim() !== '') {
        textLines.push(lines[i])
        i++
      }
      cues.push({
        index: cues.length,
        start: timingMatch[1],
        end: timingMatch[2],
        text: textLines.join('\n'),
      })
    }
    i++
  }

  return cues
}
